import api from "@/modules/home/services/statistics";

const state = () => ({
    statOrder: {
        amount: null,
        count: null,
        doing: null,
        timespend: null,
        global: null
    },
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    }
})

const getters = {
}

const actions = {
    loadOrdersStatistics({ commit, dispatch }){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getStatistics()
            .then((r)=>{
                commit('SET_STAT_GLOBAL',r.data)
                dispatch('loadStatAmount')
            })
            .catch((e) => {
                dispatch('error')
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    loadStatAmount({ commit,dispatch }){
        api.getStatisticAmounts()
            .then((r)=>{
                commit('SET_STAT_AMOUNT',r.data)
                dispatch('loadStatCount')
            })
            .catch((e) => {
                dispatch('error',e)
                commit('SET_API_DATA_FETCH_ERROR')
            });
    },
    loadStatCount({ commit, dispatch }){
        api.getStatisticCount()
            .then((r)=>{
                commit('SET_STAT_COUNT',r.data)
                dispatch('loadStatDoing')
            })
            .catch((e) => {
                dispatch('error',e)
                commit('SET_API_DATA_FETCH_ERROR')
            });
    },
    loadStatDoing({ commit, dispatch }){
        api.getStatisticDoing()
            .then((r)=>{
                commit('SET_STAT_DOING',r.data)
                dispatch('loadTimeSpend')
            })
            .catch((e) => {
                dispatch('error',e)
                commit('SET_API_DATA_FETCH_ERROR')
            });
    },
    loadTimeSpend({ commit, dispatch }){
        api.getStatisticTimeSpend()
            .then((r)=>{
                commit('SET_API_DATA_FETCH_SUCCESS')
                commit('SET_STAT_TIMESPEND',r.data)
            })
            .catch((e) => {
                dispatch('error',e)
                commit('SET_API_DATA_FETCH_ERROR')
            });
    },
    error(e){
        // eslint-disable-next-line
        console.log(e)     
    }
}

const mutations = {
    SET_STAT_AMOUNT(state, payload) {
        state.statOrder.amount = payload
    },
    SET_STAT_COUNT(state, payload) {
        state.statOrder.count = payload
    },
    SET_STAT_DOING(state, payload) {
        state.statOrder.doing = payload
    },
    SET_STAT_TIMESPEND(state, payload) {
        state.statOrder.timespend = payload
    },
    SET_STAT_GLOBAL (state, payload) {
        state.statOrder.global = payload
    },
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
